(() => {
  'use strict';
  if (window.__proSkijorRegistrationSafeguards === '20261021-bigair-athlete') return;
  window.__proSkijorRegistrationSafeguards = '20261021-bigair-athlete';

  const propertyName = (field) => (field.name.match(/^properties\[([^\]]+)\]$/) || [])[1] || field.name;
  const value = (form, name) => String(form.elements.namedItem('properties[' + name + ']')?.value || '').trim();
  const digits = (text) => String(text || '').replace(/\D/g, '');
  const emailOkay = (text) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(text || '').trim());
  const looksLikeContact = (text) => String(text || '').includes('@') || /^\+?[\d\s().-]{7,}$/.test(String(text || '').trim());
  const qualifierProducts = Object.freeze([
    {handle:'2027-bozeman-team-registration', label:'Bozeman / Gallatin Skijor'},
    {handle:'2027-boise-nampa-team-registration', label:'Boise / Nampa'},
    {handle:'2027-denver-team-registration', label:'Denver'},
    {handle:'2027-heber-city-team-registration', label:'Heber City'},
  ]);
  const proCardProduct = Object.freeze({handle:'2027-team-pro-card', label:'Add a Team PRO Card'});

  function addStyles() {
    if (document.getElementById('ps-registration-safeguards-style')) return;
    const style = document.createElement('style');
    style.id = 'ps-registration-safeguards-style';
    style.textContent = [
      '.ps-registration-note,.ps-registration-errors,.ps-registration-review{margin:1.5rem 0;padding:1.25rem 1.4rem;border:2px solid #f4ad22;background:#0b0b0b;color:#fff}',
      '.ps-registration-note strong,.ps-registration-review h3{color:#f4ad22;letter-spacing:.04em;text-transform:uppercase}',
      '.ps-registration-note p,.ps-registration-review p{margin:.45rem 0 0;color:#fff}',
      '.ps-registration-errors{border-color:#b42318;background:#fff5f3;color:#0b0b0b}',
      '.ps-registration-errors h3{margin:0 0 .5rem;color:#b42318}',
      '.ps-registration-errors ul{margin:.5rem 0 0;padding-left:1.4rem}',
      '.ps-field-error{display:block;margin:.35rem 0 .75rem;color:#b42318;font-weight:700;font-size:.9em}',
      '.ps-invalid{border-color:#b42318!important;box-shadow:0 0 0 1px #b42318!important}',
      '.ps-registration-review dl{display:grid;grid-template-columns:minmax(8rem,auto) 1fr;gap:.45rem 1rem;margin:1rem 0}',
      '.ps-registration-review dt{color:#f4ad22;font-weight:800;text-transform:uppercase}',
      '.ps-registration-review dd{margin:0;color:#fff;overflow-wrap:anywhere}',
      '.ps-registration-review-actions{display:flex;gap:.75rem;flex-wrap:wrap;margin-top:1rem}',
      '.ps-registration-review button{min-height:44px;padding:.8rem 1.1rem;border:2px solid #f4ad22;font:inherit;font-weight:800;cursor:pointer}',
      '.ps-registration-confirm{background:#f4ad22;color:#0b0b0b}',
      '.ps-registration-edit{background:transparent;color:#fff}',
      '.ps-registration-confirm:focus-visible,.ps-registration-edit:focus-visible,.ps-tour-builder__option:focus-within{outline:3px solid #fff;outline-offset:3px}',
      '.ps-quantity-locked{opacity:.75;pointer-events:none}',
      '.ps-tour-builder{grid-column:1/-1;margin-top:.5rem;padding:1.5rem;border:2px solid #f4ad22;background:#0b0b0b;color:#fff}',
      '.ps-tour-builder__eyebrow{display:block;color:#f4ad22;font-weight:800;letter-spacing:.09em;text-transform:uppercase}',
      '.ps-tour-builder h3{margin:.35rem 0 .6rem;color:#fff;font-weight:800;letter-spacing:.03em;text-transform:uppercase}',
      '.ps-tour-builder p{margin:.4rem 0 1rem;color:#fff}',
      '.ps-tour-builder__options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.65rem}',
      '.ps-tour-builder__option{display:flex;align-items:center;gap:.7rem;min-height:48px;padding:.7rem;border:1px solid #696969;background:#151515;color:#fff;font-weight:700;cursor:pointer}',
      '.ps-tour-builder__option:hover,.ps-tour-builder__option:focus-within{border-color:#f4ad22;background:#201b12}',
      '.ps-tour-builder__option input{width:20px;height:20px;accent-color:#f4ad22}',
      '.ps-tour-builder__status{display:block;margin-top:.8rem;color:#d7d7d7}',
      '.ps-new-team-intro{grid-column:1/-1;margin:1.1rem 0 .2rem;padding:1.35rem 1.5rem;border-top:2px solid #f4ad22;border-bottom:1px solid #393939;background:#111}',
      '.ps-new-team-intro h3{margin:0 0 .55rem;color:#fff;font-family:Oswald,Arial,sans-serif;font-size:clamp(1.55rem,3vw,2rem);font-weight:800;letter-spacing:.04em;text-transform:uppercase}',
      '.ps-new-team-intro p{margin:0;color:#c9c9c9;line-height:1.65}',
      '.ps-new-team-intro strong{color:#f4ad22}',
      '.ps-registration-group-heading{grid-column:1/-1;margin:1.1rem 0 -.15rem;padding-bottom:.55rem;border-bottom:1px solid #4a4a4a;color:#f4ad22;font-family:Oswald,Arial,sans-serif;font-size:1rem;font-weight:800;letter-spacing:.12em;text-transform:uppercase}',
      '.ps-registration-field{color:#f4ad22;font-family:Oswald,Arial,sans-serif;font-weight:700;letter-spacing:.06em;text-transform:uppercase}',
      '.ps-registration-field input,.ps-registration-field select,.ps-registration-field textarea{font-family:inherit;letter-spacing:normal;text-transform:none}',
      '.ps-registration-grid small,.ps-registration-grid [class*="help"],.ps-registration-grid [class*="subheading"]{color:#b8b8b8!important}',
      '.ps-tour-builder__option--pro-card{border-color:#9b741f;background:#211b0d}',
      '.ps-tour-builder__option--pro-card span strong{display:block;color:#f4ad22;font-family:Oswald,Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase}',
      '.ps-tour-builder__option--pro-card span small{display:block;margin-top:.15rem;color:#d7d7d7!important;font-weight:500}',
      '.ps-tour-builder__status[data-error="true"]{color:#ffb4ab;font-weight:700}',
      '@media(max-width:600px){.ps-registration-review dl{grid-template-columns:1fr;gap:.1rem}.ps-registration-review dd{margin-bottom:.65rem}}',
      '@media(max-width:600px){.ps-tour-builder__options{grid-template-columns:1fr}}',
      '@media(prefers-reduced-motion:reduce){.ps-registration-errors,.ps-registration-review{scroll-behavior:auto}}',
    ].join('');
    document.head.append(style);
  }

  function selectedDivision(form) {
    if (location.pathname.includes('/2027-lake-tahoe-big-air-registration')) return 'Big Air';
    const scope = form.closest('[id^="ProductInfo-"]') || form.closest('.product') || document;
    const selected = Array.from(scope.querySelectorAll('input[type="radio"]:checked'))
      .find((input) => String(input.name || '').trim().toLowerCase().startsWith('division'));
    return String(selected?.value || '').trim();
  }

  function fieldFor(form, property) {
    const aliases = {
      'Skier or Snowboarder Name':['Skier or Snowboarder Name','Athlete Name'],
      'Skier or Snowboarder Email':['Skier or Snowboarder Email','Athlete Email'],
      'Skier or Snowboarder Cell Phone':['Skier or Snowboarder Cell Phone','Athlete Cell Phone'],
      'Main Team Contact':['Main Team Contact','Main Contact Role'],
    }[property] || [property];
    for (const alias of aliases) {
      const field = form.elements.namedItem('properties[' + alias + ']');
      if (field) return field;
    }
    return null;
  }

  function clearErrors(form) {
    form.querySelector('.ps-registration-errors')?.remove();
    form.querySelectorAll('.ps-field-error').forEach((node) => node.remove());
    form.querySelectorAll('.ps-invalid').forEach((field) => {
      field.classList.remove('ps-invalid');
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
    });
  }

  function validate(form) {
    const problems = [];
    const required = Array.from(form.querySelectorAll('[name^="properties["][required]'));
    for (const field of required) {
      if(field.disabled)continue;
      if ((field.type==='checkbox'&&!field.checked)||!String(field.value || '').trim()) {
        problems.push({field, message:propertyName(field) + ' is required.'});
      }
    }

    for (const name of ['Team Name','Horse Name','Rider Name','Skier or Snowboarder Name']) {
      const field = fieldFor(form, name);
      if (!field?.disabled && field?.value && looksLikeContact(field.value)) {
        problems.push({field, message:name + ' must be a name, not an email address or phone number.'});
      }
    }
    for (const name of ['Rider Email','Skier or Snowboarder Email','Main Contact Email']) {
      const field = fieldFor(form, name);
      if (!field?.disabled && field?.value && !emailOkay(field.value)) problems.push({field, message:'Enter a valid ' + name.toLowerCase() + '.'});
    }
    for (const name of ['Rider Cell Phone','Skier or Snowboarder Cell Phone','Main Contact Cell Phone']) {
      const field = fieldFor(form, name);
      if (!field?.disabled && field?.value && digits(field.value).length < 7) problems.push({field, message:'Enter a valid ' + name.toLowerCase() + ' with at least seven digits.'});
    }

    const division = selectedDivision(form).toLowerCase();
    if (division === 'open' && currentProductHandle() !== '2027-bozeman-team-registration') problems.push({field:null,message:'OPEN is available only at Bozeman Gallatin Skijor.'});
    const athleteType = value(form, 'Athlete Type').toLowerCase();
    if (division === 'snowboard' && athleteType && athleteType !== 'snowboarder') {
      problems.push({field:fieldFor(form, 'Athlete Type'), message:'The Snowboard division requires Snowboarder as the athlete type.'});
    }
    if (division === 'pro' && athleteType === 'snowboarder') {
      problems.push({field:fieldFor(form, 'Athlete Type'), message:'Select the Snowboard division at the top of this page for a snowboarder, then review your event selections.'});
    }

    const image = fieldFor(form, 'Team Profile Image');
    const file = image?.files?.[0];
    if (file && !String(file.type).startsWith('image/')) problems.push({field:image, message:'The team profile upload must be an image.'});
    if (file && file.size > 10 * 1024 * 1024) problems.push({field:image, message:'The team profile image must be 10 MB or smaller.'});

    return problems.filter((problem, index, all) => all.findIndex((candidate) => candidate.field === problem.field && candidate.message === problem.message) === index);
  }

  function showErrors(form, problems) {
    clearErrors(form);
    const box = document.createElement('div');
    box.className = 'ps-registration-errors';
    box.setAttribute('role', 'alert');
    box.setAttribute('tabindex', '-1');
    const heading = document.createElement('h3');
    heading.textContent = 'Please correct ' + problems.length + (problems.length === 1 ? ' item' : ' items') + ' before continuing';
    const list = document.createElement('ul');
    box.append(heading, list);

    problems.forEach((problem, index) => {
      const item = document.createElement('li');
      item.textContent = problem.message;
      list.append(item);
      if (!problem.field) return;
      const error = document.createElement('span');
      const id = 'ps-field-error-' + index + '-' + Math.random().toString(36).slice(2, 7);
      error.id = id;
      error.className = 'ps-field-error';
      error.textContent = problem.message;
      problem.field.classList.add('ps-invalid');
      problem.field.setAttribute('aria-invalid', 'true');
      problem.field.setAttribute('aria-describedby', id);
      problem.field.insertAdjacentElement('afterend', error);
    });

    form.prepend(box);
    box.focus({preventScroll:true});
    box.scrollIntoView({behavior:'smooth', block:'center'});
    setTimeout(() => problems[0]?.field?.focus({preventScroll:true}), 500);
  }

  function showReview(form, submitter) {
    form.querySelector('.ps-registration-review')?.remove();
    const review = document.createElement('section');
    review.className = 'ps-registration-review';
    review.setAttribute('aria-labelledby', 'ps-registration-review-title');
    review.setAttribute('tabindex', '-1');
    const title = document.createElement('h3');
    title.id = 'ps-registration-review-title';
    title.textContent = selectedDivision(form)==='Big Air'?'Review your Big Air athlete entry':'Review your official roster';
    const instruction = document.createElement('p');
    instruction.textContent = 'Please confirm the spelling, division, athlete names, and contact information. This information creates and connects your Meet the Teams profile.';
    const details = document.createElement('dl');
    const rows = [
      ['Event', document.querySelector('h1')?.textContent?.trim() || document.title.split('–')[0].trim()],
      ['Division', selectedDivision(form)],
      [selectedDivision(form)==='Big Air'?'Athlete entry':'Team', value(form, 'Team Name')],
      ['Horse', value(form, 'Horse Name') || (selectedDivision(form)==='Big Air'?'Optional / staff pairing':'')],
      ['Rider', value(form, 'Rider Name') || (selectedDivision(form)==='Big Air'?'Optional / staff pairing':'')],
      ...(selectedDivision(form)==='Big Air'?[['Horse/rider arrangement',value(form,'Big Air Horse and Rider Arrangement')]]:[]),
      ['Skier / Snowboarder', value(form, 'Skier or Snowboarder Name')],
      ['Main contact', value(form, 'Main Contact Name') + ' · ' + value(form, 'Main Contact Email')],
    ];
    rows.forEach(([label, content]) => {
      const term = document.createElement('dt'); term.textContent = label;
      const description = document.createElement('dd'); description.textContent = content || 'Not provided';
      details.append(term, description);
    });
    const actions = document.createElement('div'); actions.className = 'ps-registration-review-actions';
    const confirm = document.createElement('button'); confirm.type = 'button'; confirm.className = 'ps-registration-confirm'; confirm.textContent = 'CONFIRM & ADD TO CART';
    const edit = document.createElement('button'); edit.type = 'button'; edit.className = 'ps-registration-edit'; edit.textContent = 'EDIT INFORMATION';
    actions.append(confirm, edit);
    review.append(title, instruction, details, actions);
    form.querySelector('[type="submit"]')?.insertAdjacentElement('beforebegin', review);

    confirm.addEventListener('click', () => {
      form.dataset.psRosterConfirmed = 'true';
      review.remove();
      form.requestSubmit(submitter || form.querySelector('[type="submit"]'));
    });
    edit.addEventListener('click', () => {
      review.remove();
      fieldFor(form, 'Team Name')?.focus();
    });
    review.focus({preventScroll:true});
    review.scrollIntoView({behavior:'smooth', block:'center'});
  }

  function lockQuantity(form) {
    const quantity = form.querySelector('input[name="quantity"]') || (form.closest('[id^="ProductInfo-"]') || document).querySelector('input[name="quantity"]');
    if (!quantity) return;
    quantity.value = '1';
    quantity.min = '1';
    quantity.max = '1';
    quantity.readOnly = true;
    quantity.setAttribute('aria-label', 'Quantity locked to one named team');
    quantity.closest('quantity-input, .quantity')?.classList.add('ps-quantity-locked');
    quantity.addEventListener('change', () => { quantity.value = '1'; });
  }

  function currentProductHandle() {
    return (location.pathname.match(/^\/products\/([^/?#]+)/) || [])[1] || '';
  }

  function propertyEntries(form) {
    return Array.from(form.elements)
      .filter((field) => /^properties\[[^\]]+\]$/.test(field.name || ''))
      .filter((field) => field.type !== 'file' && field.type !== 'submit' && field.type !== 'button')
      .filter((field) => !((field.type === 'checkbox' || field.type === 'radio') && !field.checked))
      .map((field) => ({name:propertyName(field), value:String(field.value || '')}));
  }

  function removeAdditionalItems(form) {
    form.querySelectorAll('[data-ps-additional-item]').forEach((field) => field.remove());
  }

  function additionalInput(form, name, value) {
    const field = document.createElement('input');
    field.type = 'hidden';
    field.name = name;
    field.value = value;
    field.dataset.psAdditionalItem = 'true';
    form.append(field);
  }

  function prepareAdditionalItems(form) {
    removeAdditionalItems(form);
    const builder = form.querySelector('[data-ps-tour-builder]');
    if (!builder) return;
    const properties = propertyEntries(form);
    let index = 1;
    builder.querySelectorAll('[data-ps-tour-item]:checked').forEach((box) => {
      if (!box.dataset.variantId) return;
      const itemProperties = propertiesForTourItem(form, box, properties);
      additionalInput(form, 'shopify-additional-items[' + index + '][id]', box.dataset.variantId);
      additionalInput(form, 'shopify-additional-items[' + index + '][quantity]', '1');
      itemProperties.forEach((property) => additionalInput(
        form,
        'shopify-additional-items[' + index + '][properties][' + property.name + ']',
        property.value,
      ));
      index += 1;
    });
  }

  function selectedTourItems(form) {
    const baseProperties = propertyEntries(form);
    return Array.from(form.querySelectorAll('[data-ps-tour-item]:checked'))
      .filter((box) => box.dataset.variantId)
      .map((box) => ({
        id:Number(box.dataset.variantId),
        quantity:1,
        properties:Object.fromEntries(propertiesForTourItem(form, box, baseProperties).map(({name, value}) => [name, value])),
      }));
  }

  function propertiesForTourItem(form, box, baseProperties = propertyEntries(form)) {
    if (box.dataset.psProCard !== 'true') return baseProperties;
    const division = selectedDivision(form);
    const contactEmail = value(form, 'Main Contact Email') || value(form, 'Rider Email') || value(form, 'Skier or Snowboarder Email');
    const additions = {
      'Team Division':division,
      'Team Contact Email':contactEmail,
      'PRO Card Declaration':'Accepted',
      'Team Match Key':value(form, 'Team Match Key'),
    };
    const merged = new Map(baseProperties.map((property) => [property.name, property.value]));
    Object.entries(additions).forEach(([name, propertyValue]) => merged.set(name, propertyValue));
    return Array.from(merged, ([name, propertyValue]) => ({name, value:propertyValue}));
  }

  function propertyObject(form) {
    return Object.fromEntries(propertyEntries(form).map(({name, value}) => [name, value]));
  }

  async function addTourScheduleToCart(form, submitter) {
    const extras = selectedTourItems(form);
    if (!extras.length) return false;
    const variantId = Number(form.elements.namedItem('id')?.value || 0);
    if (!variantId) throw new Error('Choose a division before adding this schedule.');
    const properties = propertyObject(form);
    const image = fieldFor(form, 'Team Profile Image');
    const hasUpload = Boolean(image?.files?.length);
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
      submitter.dataset.psOriginalText = submitter.textContent;
      submitter.textContent = 'ADDING TOUR SCHEDULE...';
    }
    try {
      if (hasUpload) {
        const first = await fetch('/cart/add.js', {
          method:'POST', headers:{Accept:'application/json'}, body:new FormData(form),
        });
        if (!first.ok) throw new Error((await first.json().catch(() => ({}))).description || 'This event could not be added.');
        const more = await fetch('/cart/add.js', {
          method:'POST',
          headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify({items:extras.map((item) => ({id:item.id, quantity:item.quantity, properties:item.properties || properties}))}),
        });
        if (!more.ok) throw new Error((await more.json().catch(() => ({}))).description || 'The additional events could not be added.');
      } else {
        const response = await fetch('/cart/add.js', {
          method:'POST',
          headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify({items:[
            {id:variantId, quantity:1, properties},
            ...extras.map((item) => ({id:item.id, quantity:item.quantity, properties:item.properties || properties})),
          ]}),
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).description || 'The tour schedule could not be added.');
      }
      location.assign('/cart');
      return true;
    } catch (error) {
      if (submitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
        submitter.textContent = submitter.dataset.psOriginalText || 'ADD TO CART';
      }
      showErrors(form, [{field:null, message:error.message || 'The tour schedule could not be added. Please try again.'}]);
      return true;
    }
  }

  async function loadQualifier(handle) {
    const response = await fetch('/products/' + handle + '.js', {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Unable to load ' + handle);
    return response.json();
  }

  function matchingVariant(product, division) {
    const wanted = String(division || '').trim().toLowerCase();
    return (product.variants || []).find((variant) => {
      const title = String(variant.title || variant.option1 || '').trim().toLowerCase();
      return title === wanted;
    });
  }

  async function buildTourSchedule(form) {
    const handle = currentProductHandle();
    if (!qualifierProducts.some((event) => event.handle === handle)) return;
    const old = Array.from(form.querySelectorAll('.ps-multiple-events'))[0];
    const host = old || document.createElement('div');
    host.className = 'ps-tour-builder';
    host.dataset.psTourBuilder = 'true';
    host.innerHTML = '<span class="ps-tour-builder__eyebrow">BUILD YOUR TOUR SCHEDULE IN ONE CHECKOUT</span><h3>ADD EVENTS AND A PRO CARD</h3><p>Complete this team information once, then select any additional qualifiers and add a Team PRO Card if desired. Every selected item will be added to one cart and connected to this same team profile.</p><div class="ps-tour-builder__options" data-ps-tour-options></div><small class="ps-tour-builder__status" data-ps-tour-status>Loading available qualifier registrations and Team PRO Card...</small>';
    if (!old) form.querySelector('[type="submit"]')?.insertAdjacentElement('beforebegin', host);
    const options = host.querySelector('[data-ps-tour-options]');
    const status = host.querySelector('[data-ps-tour-status]');
    const otherEvents = qualifierProducts.filter((event) => event.handle !== handle);
    try {
      const products = await Promise.all(otherEvents.map((event) => loadQualifier(event.handle)));
      const proCard = await loadQualifier(proCardProduct.handle);
      otherEvents.forEach((event, eventIndex) => {
        const label = document.createElement('label');
        label.className = 'ps-tour-builder__option';
        const box = document.createElement('input');
        box.type = 'checkbox';
        box.dataset.psTourItem = 'true';
        box.dataset.psTourEvent = event.handle;
        box.dataset.productIndex = String(eventIndex);
        const text = document.createElement('span'); text.textContent = event.label;
        label.append(box, text); options.append(label);
      });
      const proCardVariant = (proCard.variants || []).find((variant) => variant.available !== false);
      const proCardLabel = document.createElement('label');
      proCardLabel.className = 'ps-tour-builder__option ps-tour-builder__option--pro-card';
      const proCardBox = document.createElement('input');
      proCardBox.type = 'checkbox';
      proCardBox.dataset.psTourItem = 'true';
      proCardBox.dataset.psProCard = 'true';
      proCardBox.dataset.variantId = proCardVariant?.id || '';
      proCardBox.disabled = !proCardVariant;
      const proCardText = document.createElement('span');
      proCardText.innerHTML = '<strong>' + proCardProduct.label + '</strong><small>Declare this team for the PRO Skijor Tour and activate points tracking.</small>';
      proCardLabel.append(proCardBox, proCardText);
      options.append(proCardLabel);
      const refresh = () => {
        const division = selectedDivision(form);
        const bigAir = division.trim().toUpperCase() === 'BIG AIR';
        const community = location.pathname.includes('/2027-lake-tahoe-community-registration');
        const open = ['OPEN','BIG AIR'].includes(division.trim().toUpperCase()) || community;
        host.querySelector('h3').textContent = bigAir ? 'BIG AIR ENTRY' : community ? 'TAHOE COMMUNITY EVENT' : open ? 'BOZEMAN OPEN' : 'ADD EVENTS AND A PRO CARD';
        const intro=host.querySelector('p');
        intro.dataset.psOriginalCopy ||= intro.textContent;
        intro.textContent=bigAir ? 'A separate Big Air competition for experienced aerial athletes. This entry does not enter the Championship Finals or earn Tour points. No Team PRO Card is required.' : community ? 'An opportunity to join the Lake Tahoe weekend, separate from the earned Championship Finals. Community registration does not qualify a team for the Finals or earn Tour points. No Team PRO Card is required.' : open ? "OPEN is available only at Bozeman Gallatin Skijor. This event-only division offers additional racing and podium prize money, but does not award PRO Skijor Tour points or qualify teams for the Championship Finals. To pursue Tour points, enter PRO, Sport, Women's, Snowboard or All-Around and meet the Team PRO Card and Tour eligibility requirements. A Team PRO Card does not make an OPEN entry eligible for Tour points." : intro.dataset.psOriginalCopy;
        proCardBox.disabled=open || !proCardVariant;
        proCardLabel.hidden=open;
        if(open)proCardLabel.style.setProperty('display','none','important');else proCardLabel.style.removeProperty('display');
        if(open)proCardBox.checked=false;
        let available = 0;
        options.querySelectorAll('[data-ps-tour-event]').forEach((box) => {
          const variant = matchingVariant(products[Number(box.dataset.productIndex)], division);
          box.dataset.variantId = variant?.id || '';
          box.disabled = open || !variant || variant.available === false;
          box.closest('label').hidden=open;
          if(open)box.closest('label').style.setProperty('display','none','important');else box.closest('label').style.removeProperty('display');
          if (box.disabled) box.checked = false;
          else available += 1;
        });
        status.dataset.error = open || available ? 'false' : 'true';
        status.textContent = bigAir ? '$35 per entry. Twelve entries per event, with a maximum of two per skier or snowboarder. Register each athlete entry separately. Horse and rider details are optional.' : community ? 'Novice/Sport: 25 teams each; Women’s/Snowboard: 20 each; All-Around/Century/Lil Buckaroo: 12 each. Lil Buckaroo $75; all other Community divisions $150.' : open ? '$200 per team. Limited to 30 OPEN entries. No Tour points or Team PRO Card eligibility. Use a separately named team for a different division.' : division
          ? (available ? 'Choose additional stops and, if desired, add a Team PRO Card for this ' + division + ' team.' : 'No additional ' + division + ' registrations are currently available. You may still add a Team PRO Card.')
          : 'Select a division above to see matching qualifier registrations.';
      };
      const divisionScope = form.closest('[id^="ProductInfo-"]') || form.closest('.product') || document;
      divisionScope.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"], select')) refresh();
      });
      refresh();
    } catch {
      status.dataset.error = 'true';
      status.textContent = 'Additional qualifier options could not be loaded. You can still register for this event normally.';
    }
  }

  function ensureHiddenProperty(form, name) {
    let field = form.elements.namedItem('properties[' + name + ']');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[' + name + ']';
      form.append(field);
    }
    return field;
  }

  function ensureProfileFields(form) {
    ensureHiddenProperty(form, 'Registration Schema Version').value = '2';
    const definitions = [
      {name:'Rider Age', label:'RIDER AGE', after:'Rider Name', type:'number', required:true, min:'1', max:'100'},
      {name:'Rider Current Hometown', label:'RIDER CURRENT HOMETOWN (CITY, STATE/PROVINCE)', after:'Rider Age', required:true},
      {name:'Skier or Snowboarder Age', label:'SKIER / SNOWBOARDER AGE', after:'Skier or Snowboarder Name', type:'number', required:true, min:'1', max:'100'},
      {name:'Skier or Snowboarder Current Hometown', label:'SKIER / SNOWBOARDER CURRENT HOMETOWN (CITY, STATE/PROVINCE)', after:'Skier or Snowboarder Age', required:true},
      {name:'Team Motto', label:'TEAM MOTTO (OPTIONAL)', after:'Team Name', maxlength:'120'},
    ];
    const missing = definitions.filter((definition) => !form.elements.namedItem('properties[' + definition.name + ']'));
    missing.forEach((definition) => {
      const wrapper = document.createElement('label');
      wrapper.className = 'ps-registration-field';
      wrapper.textContent = definition.label + (definition.required ? ' *' : '');
      const field = document.createElement('input');
      field.type = definition.type || 'text';
      field.name = 'properties[' + definition.name + ']';
      field.autocomplete = 'off';
      if (definition.required) field.required = true;
      if (definition.min) field.min = definition.min;
      if (definition.max) field.max = definition.max;
      if (definition.maxlength) field.maxLength = Number(definition.maxlength);
      wrapper.append(field);
      const anchor = fieldFor(form, definition.after)?.closest('label,.ps-registration-field');
      if (anchor?.parentNode) anchor.insertAdjacentElement('afterend', wrapper);
      else form.append(wrapper);
    });
  }

  function addGroupHeading(form, beforeProperty, text) {
    const target = fieldFor(form, beforeProperty)?.closest('label,.ps-registration-field');
    if (!target?.parentNode || target.previousElementSibling?.dataset.psGroupHeading === text) return;
    const heading = document.createElement('h4');
    heading.className = 'ps-registration-group-heading';
    heading.dataset.psGroupHeading = text;
    heading.textContent = text;
    target.insertAdjacentElement('beforebegin', heading);
  }

  function improveNewTeamFlow(form) {
    if (form.querySelector('[data-ps-new-team-intro]')) return;
    const teamName = fieldFor(form, 'Team Name')?.closest('label,.ps-registration-field');
    if (!teamName?.parentNode) return;
    const intro = document.createElement('section');
    intro.className = 'ps-new-team-intro';
    intro.dataset.psNewTeamIntro = 'true';
    intro.innerHTML = '<h3>REGISTER A NEW TEAM</h3><p><strong>First, select your division at the top of this page.</strong> Then enter the team information below, completing every required field and as many optional profile details as possible. You can edit the profile later in Team Manager, but adding more information now creates a stronger Meet the Teams profile from day one.</p>';
    teamName.insertAdjacentElement('beforebegin', intro);
    addGroupHeading(form, 'Horse Name', 'HORSE INFORMATION');
    addGroupHeading(form, 'Rider Name', 'RIDER INFORMATION');
    addGroupHeading(form, 'Athlete Type', 'SKIER / SNOWBOARDER INFORMATION');
    addGroupHeading(form, 'Main Team Contact', 'TEAM CONTACT & PROFILE INFORMATION');
  }

  function moveProfilePhotoBeforeProfilePromotion(form) {
    const photo = form.querySelector('.ps-photo-upload');
    const promotion = form.querySelector('.ps-profile-builder');
    if (!photo || !promotion || photo.parentElement !== promotion) return;
    promotion.insertAdjacentElement('beforebegin', photo);
  }

  function writeSavedValue(form, property, nextValue) {
    if (nextValue === undefined || nextValue === null) return;
    const field = fieldFor(form, property);
    if (!field) return;
    const normalized = String(nextValue);
    if (field.type === 'radio' || field.type === 'checkbox') {
      const choices = Array.from(form.querySelectorAll('[name="' + CSS.escape(field.name) + '"]'));
      const wanted = normalized.trim().toLowerCase();
      choices.forEach((choice) => {
        choice.checked = String(choice.value || '').trim().toLowerCase() === wanted;
      });
      const selected = choices.find((choice) => choice.checked);
      selected?.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    field.value = normalized;
    field.dispatchEvent(new Event('input', {bubbles:true}));
    field.dispatchEvent(new Event('change', {bubbles:true}));
  }

  function applySavedTeam(form, team) {
    const fields = {
      'Team Name':team.teamName,
      'Horse Name':team.horseName,
      'Horse Age':team.horseAge,
      'Horse Breed':team.horseBreed,
      'Horse Color':team.horseColor,
      'Rider Name':team.riderName,
      'Rider Age':team.riderAge,
      'Rider Current Hometown':team.riderHometown,
      'Rider Email':team.riderEmail,
      'Rider Cell Phone':team.riderCellPhone,
      'Athlete Type':team.athleteType,
      'Skier or Snowboarder Name':team.athleteName,
      'Skier or Snowboarder Age':team.athleteAge,
      'Skier or Snowboarder Current Hometown':team.athleteHometown,
      'Skier or Snowboarder Email':team.athleteEmail,
      'Skier or Snowboarder Cell Phone':team.athleteCellPhone,
      'Main Team Contact':team.mainContactRole,
      'Main Contact Name':team.mainContactName,
      'Main Contact Email':team.mainContactEmail,
      'Main Contact Cell Phone':team.mainContactCellPhone,
      'Rider Social Media URL':team.riderSocialUrl,
      'Skier or Snowboarder Social Media URL':team.athleteSocialUrl,
      'Team Sponsors':team.sponsors,
      'Team Bio':team.bio,
      'Team Motto':team.teamMotto,
      'Team Video URL':team.videoUrl,
    };
    Object.entries(fields).forEach(([property, nextValue]) => writeSavedValue(form, property, nextValue));
    ensureHiddenProperty(form, 'Existing Team ID').value = team.id || '';
    ensureHiddenProperty(form, 'Team Match Key').value = team.teamMatchKey || '';
    ensureHiddenProperty(form, 'Team Profile Image URL').value = team.featureImage || '';
  }

  function improveSavedTeamReuse(form) {
    const select = form.querySelector('[data-ps-saved-team]');
    if (!select || select.dataset.psCompleteReuse === 'true') return;
    select.dataset.psCompleteReuse = 'true';
    let teams = [];
    let publicTeams = [];
    const token = new URLSearchParams(location.search).get('team_session');
    const endpoint = token
      ? 'https://pro-skijor-team-manager.onrender.com/storefront/team-session?token=' + encodeURIComponent(token)
      : '/apps/team-manager';
    const teamsReady = fetch(endpoint, {headers:{Accept:'application/json'}, credentials:'same-origin'})
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('team-load')))
      .then((data) => { teams = Array.isArray(data.teams) ? data.teams : []; })
      .catch(() => {});
    const publicTeamsReady = fetch('https://pro-skijor-team-manager.onrender.com/api/public/teams', {headers:{Accept:'application/json'}})
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('public-team-load')))
      .then((data) => { publicTeams = Array.isArray(data.teams) ? data.teams : []; })
      .catch(() => {});
    select.addEventListener('change', async () => {
      await Promise.all([teamsReady, publicTeamsReady]);
      const team = teams[Number(select.value)];
      if (!team) return;
      const publicTeam = publicTeams.find((profile) => String(profile.id || '') === String(team.id || '')) || {};
      const completeTeam = {
        ...publicTeam,
        ...team,
        bio:team.bio || publicTeam.bio || '',
        sponsors:team.sponsors || publicTeam.sponsors || '',
        riderSocialUrl:team.riderSocialUrl || publicTeam.riderSocialUrl || '',
        athleteSocialUrl:team.athleteSocialUrl || publicTeam.athleteSocialUrl || '',
        videoUrl:team.videoUrl || publicTeam.videoUrl || '',
        featureImage:team.featureImage || (publicTeam.hasUploadedFeatureImage ? publicTeam.featureImage : ''),
      };
      applySavedTeam(form, completeTeam);
      const status = form.querySelector('[data-ps-saved-status]');
      if (status) status.textContent = completeTeam.featureImage
        ? 'Your complete saved roster, story, sponsors, contacts, and profile photo are connected to this registration. Review the information below, then continue.'
        : 'Your complete saved roster and profile details are connected. Review the information below. You can upload a profile photo now or add one later in Team Manager.';
    });
  }


  function specialEntryFields(form) {
    if(form.querySelector('[name="properties[Big Air / Aerial Experience]"]'))return;
    const scope=form.closest('[id^="ProductInfo-"]')||form.closest('.product')||document;
    const box=document.createElement('section');box.className='ps-registration-note';
    box.innerHTML='<strong>Big Air: bring the skill. Own the moment.</strong><p>A crowd favorite, captured by cameras and cheered from the sidelines. $35 per entry, 12 entry slots per event, maximum two entries per skier/snowboarder. Guaranteed Big Air cash: $1,750 minimum total at each qualifier and $3,000 at the Championship Finals, paid 1st–4th at 40% / 30% / 20% / 10%. First-place buckles and sponsor prizes add to the excitement. <a href="/pages/cash-payouts#big-air-payouts">See exact payouts</a>.</p><p>This is for experienced aerial athletes who can safely perform and land tricks after a horse-towed approach to a large kicker. It is not a first-jump lesson. Event staff retain final safety approval and may adjust or stop participation for conditions or demonstrated ability.</p><label>Describe your aerial experience<textarea name="properties[Big Air / Aerial Experience]"></textarea></label><label>Video / reel showing your experience<input type="url" name="properties[Skill Evidence URL]" placeholder="https://"></label><label><input type="checkbox" name="properties[Big Air Safety Acknowledgment]" value="Accepted"> I am experienced and comfortable safely performing and landing aerial stunts from a large kicker after a horse-towed rope approach. I understand staff safety approval, helmet requirements and event briefings apply.</label>';
    const buttons=form.querySelector('.product-form__buttons');if(buttons)buttons.before(box);else form.append(box);
    const refresh=()=>{const big=selectedDivision(form)==='Big Air';box.hidden=!big;box.querySelectorAll('input,textarea').forEach(f=>{f.disabled=!big;f.required=big;});};
    scope.addEventListener('change',refresh);refresh();
  }

  async function waitingList(form) {
    if(form.querySelector('[data-waitlist-join]'))return;
    const handle=location.pathname.split('/products/')[1]?.split('/')[0];if(!handle||!handle.includes('registration'))return;
    const scope=form.closest('[id^="ProductInfo-"]')||form.closest('.product')||document;
    const box=document.createElement('section');box.className='ps-registration-note';box.hidden=true;
    box.innerHTML='<strong>Sold out? Keep your team in the running.</strong><p>Join the free waiting list for this event and division. Complete the same roster below. Requests are recorded in received order. No charge, guaranteed opening or registered entry is created. If a place opens, we email the next team a secure checkout with a 24-hour reservation. A spot is confirmed only after payment.</p><button type="button" class="button" data-waitlist-join>JOIN THE FREE WAITING LIST</button><p role="status" data-waitlist-status></p>';
    form.append(box);let ready=false;
    const refresh=async()=>{try{const r=await fetch('/products/'+handle+'.js',{headers:{Accept:'application/json'}});if(!r.ok)return;const p=await r.json();const id=String(form.elements.namedItem('id')?.value||'');const v=p.variants.find(v=>String(v.id)===id);ready=!!v&&!v.available;box.hidden=!ready;}catch{}};
    scope.addEventListener('change',refresh);await refresh();
    box.querySelector('[data-waitlist-join]').addEventListener('click',async()=>{
      const status=box.querySelector('[data-waitlist-status]');if(!ready)return;
      const problems=validate(form);if(problems.length){showErrors(form,problems);return;}
      const button=box.querySelector('button');button.disabled=true;status.textContent='Recording your request…';
      try{const properties={};new FormData(form).forEach((v,k)=>{const m=k.match(/^properties\[([^\]]+)\]$/);if(m&&typeof v==='string')properties[m[1]]=v;});
        const token=new URLSearchParams(location.search).get('team_session');const response=await fetch(token?'https://pro-skijor-team-manager.onrender.com/storefront/waitlist':'/apps/team-manager?action=waitlist',{method:'POST',headers:{'content-type':'application/json',...(token?{authorization:'Bearer '+token}:{})},body:JSON.stringify({variantId:form.elements.namedItem('id')?.value,properties})});const data=await response.json();
        if(response.status===401){status.textContent='Please sign in to your PRO Skijor account, return to this event and join the waiting list. Your place is recorded when signup is completed.';const a=document.createElement('a');a.href='/customer_authentication/login?return_to='+encodeURIComponent(location.pathname+location.search);a.textContent=' Sign in';status.append(a);return;}
        if(!response.ok)throw Error(data.error||'We could not record your waiting-list request.');status.textContent=data.message+' Your current queue position is '+data.position+'.';
      }catch(e){status.textContent=e.message;}finally{button.disabled=false;}
    });
  }

  function isolateSpecialEntry(form) {
    const big=selectedDivision(form)==='Big Air',community=location.pathname.includes('/2027-lake-tahoe-community-registration');
    if(!big&&!community) {
      const note=form.querySelector('aside.ps-registration-note');
      if(note?.dataset.psSpecialCopy==='true') {note.querySelector('strong').textContent='One named team, one simple registration flow';note.querySelector('p').textContent='Complete the roster for one horse, rider, and skier or snowboarder. To take this same team to more qualifiers, use the tour-schedule options below and add every selected stop in one checkout. Register a different team separately.';delete note.dataset.psSpecialCopy;}
      return;
    }
    const host=form.querySelector('.ps-tour-builder');
    if(host) {
      const intro=host.querySelector('p');if(intro&&!intro.dataset.psOriginalCopy)intro.dataset.psOriginalCopy='Complete this team information once, then select any additional qualifiers and add a Team PRO Card if desired. Every selected item will be added to one cart and connected to this same team profile.';
      for(const box of host.querySelectorAll('input[type="checkbox"]')) {box.checked=false;box.disabled=true;box.closest('label')?.setAttribute('hidden','');box.closest('label')?.style.setProperty('display','none','important');}
      const copy=[[host.querySelector('h3'),big?'BIG AIR ENTRY':'TAHOE COMMUNITY EVENT'],[host.querySelector('p'),big?'A separate competition for experienced aerial athletes. No Tour points or Championship Finals qualification. No Team PRO Card is required.':'A separate PRO Skijor Community event during the Tahoe weekend. Community entry does not enter or qualify a team for the earned Championship Finals. No Team PRO Card is required.'],[host.querySelector('[data-ps-tour-status]'),big?'$35 per entry. Twelve entry slots per event, maximum two per skier or snowboarder. Register each athlete entry separately.':'Novice/Sport: 25 teams each; Women’s/Snowboard: 20 each; All-Around/Century/Lil Buckaroo: 12 each. Lil Buckaroo $75; all other Community divisions $150.']];
      for(const [node,text] of copy)if(node&&node.textContent!==text)node.textContent=text;
    }
    const note=form.querySelector('aside.ps-registration-note');
    const heading=note?.querySelector('strong'),p=note?.querySelector('p');
    if(note)note.dataset.psSpecialCopy='true';
    const title=big?'One athlete entry, one complete roster':'Lake Tahoe Community event registration';
    const text=big?'Register as an individual skier or snowboarder. PRO Skijor can provide your horse and rider, or you may arrange your own attending pairing. Horse and rider details are optional. Register each of your maximum two entries separately. Participation is subject to staff safety approval.':'Register your Community team for the Tahoe weekend. This is separate from the earned Championship Finals and does not award Tour points or require a Team PRO Card.';
    if(heading&&heading.textContent!==title)heading.textContent=title;if(p&&p.textContent!==text)p.textContent=text;
  }

  function configureBigAirAthlete(form) {
    if(!fieldFor(form,'Team Name')||!fieldFor(form,'Athlete Type'))return;
    const big=selectedDivision(form)==='Big Air';
    let support=form.querySelector('[data-ps-air-arrangement]');
    if(!support){
      support=document.createElement('section');support.className='ps-registration-note';support.dataset.psAirArrangement='true';support.style.gridColumn='1 / -1';
      support.innerHTML='<h3>Your Big Air entry</h3><p>Register as an individual skier or snowboarder. Your athlete name is your entry name, and all Big Air cash awards belong to the placed athlete. PRO Skijor can provide your horse and rider, or you may arrange a pairing with a horse and rider already attending and entered in other divisions at this event.</p><label>Horse and rider arrangement *<select name="properties[Big Air Horse and Rider Arrangement]"><option value="">Choose one</option><option value="Provided by PRO Skijor">Please provide a horse and rider for me</option><option value="Own horse and rider">I will arrange my own attending horse and rider</option></select></label><label data-air-coordinate><input type="checkbox" name="properties[Big Air Coordination Acknowledgment]" value="Accepted"> I will coordinate with my chosen horse and rider, who are attending and entered in other divisions at this event, and make sure we are ready together at the Big Air start line at the scheduled time.</label><p data-air-own-note>Horse and rider details below are optional. Add them if known, or contact PRO Skijor once your pairing is confirmed. Event staff must confirm all pairings and check horse and rider availability and workload before competition.</p><div data-air-own-fields></div><p data-air-provided-note>PRO Skijor will arrange a horse and rider for your Big Air pull. Check in at the competitor briefing for your pairing, start time and instructions. You do not need to select or register a horse or rider to purchase this entry.</p>';
      const anchor=fieldFor(form,'Athlete Type')?.closest('label,.ps-registration-field');if(anchor)anchor.before(support);else form.prepend(support);
      const arrangementSelect=support.querySelector('select');Object.assign(arrangementSelect.style,{display:'block',width:'100%',minHeight:'48px',marginTop:'12px',padding:'12px',background:'#171717',color:'#fff',border:'1px solid #F5A800'});
      support.querySelector('[data-air-coordinate]').style.marginTop='20px';
      support.addEventListener('change',()=>configureBigAirAthlete(form));
      form.addEventListener('input',()=>{if(selectedDivision(form)==='Big Air')configureBigAirAthlete(form);});
      const scope=form.closest('[id^="ProductInfo-"]')||form.closest('.product')||document;scope.addEventListener('change',()=>configureBigAirAthlete(form));
    }
    support.hidden=!big;const choice=support.querySelector('select'),own=choice.value==='Own horse and rider',ack=support.querySelector('input');
    choice.disabled=!big;choice.required=big;ack.disabled=!big||!own;ack.required=big&&own;support.querySelector('[data-air-coordinate]').hidden=!own;support.querySelector('[data-air-own-note]').hidden=!own;support.querySelector('[data-air-provided-note]').hidden=own;
    for(const field of form.querySelectorAll('[name^="properties["]')){
      const name=propertyName(field),pair=name.startsWith('Horse ')||name.startsWith('Rider '),contact=name.startsWith('Main Contact ')||name==='Main Team Contact',entry=name==='Team Name';
      if(!pair&&!contact&&!entry)continue;
      if(field.dataset.psAirOriginalRequired===undefined){field.dataset.psAirOriginalRequired=String(field.required);field.dataset.psAirOriginalDisabled=String(field.disabled);}
      const wrapper=field.closest('label,.ps-registration-field');
      if(pair&&wrapper){
        form.psAirOriginalPositions ||= new Map();
        if(!form.psAirOriginalPositions.has(wrapper)){const marker=document.createElement('span');marker.hidden=true;wrapper.before(marker);form.psAirOriginalPositions.set(wrapper,marker);}
        const group=support.querySelector('[data-air-own-fields]');
        if(big&&wrapper.parentNode!==group)group.append(wrapper);
        if(!big&&wrapper.parentNode===group)form.psAirOriginalPositions.get(wrapper).after(wrapper);
      }
      const label=wrapper?.querySelector('span');if(pair&&label){label.dataset.psAirLabel ||= label.textContent;const text=big?label.dataset.psAirLabel.replace(/\s*\*$/, '')+' (optional)':label.dataset.psAirLabel;if(label.textContent!==text)label.textContent=text;}
      if(big){field.required=false;if(pair)field.disabled=!own;if(wrapper)wrapper.hidden=contact||entry||(pair&&!own);}
      else{field.required=field.dataset.psAirOriginalRequired==='true';field.disabled=field.dataset.psAirOriginalDisabled==='true';if(wrapper)wrapper.hidden=false;}
    }
    for(const h of form.querySelectorAll('[data-ps-group-heading]'))h.hidden=big&&(/HORSE|RIDER|TEAM CONTACT/.test(h.dataset.psGroupHeading||''));
    const intro=form.querySelector('[data-ps-new-team-intro]');if(intro){intro.dataset.psAirOriginalHtml ||= intro.innerHTML;const targetHtml=big?'<h3>REGISTER A BIG AIR ATHLETE</h3><p>Enter your skier or snowboarder details, choose how your horse and rider will be arranged, and share your aerial experience. $35 per entry, maximum two entries per athlete per event. Complete each entry separately.</p>':intro.dataset.psAirOriginalHtml;if(intro.innerHTML!==targetHtml)intro.innerHTML=targetHtml;}
    if(big){
      const set=(name,v)=>{const f=fieldFor(form,name);if(f)f.value=v||'';};
      set('Team Name',value(form,'Skier or Snowboarder Name'));set('Main Team Contact','Skier or Snowboarder');set('Main Contact Name',value(form,'Skier or Snowboarder Name'));set('Main Contact Email',value(form,'Skier or Snowboarder Email'));set('Main Contact Cell Phone',value(form,'Skier or Snowboarder Cell Phone'));
      ensureHiddenProperty(form,'Registration Schema Version').value='3';
    }else if(value(form,'Registration Schema Version')==='3')ensureHiddenProperty(form,'Registration Schema Version').value='2';
  }

  function initialize(form) {
    configureBigAirAthlete(form);
    if (form.dataset.psSafeguardsVersion === '20261021-bigair-athlete') {isolateSpecialEntry(form);return;}
    if (!fieldFor(form, 'Team Name') || !fieldFor(form, 'Horse Name') || !fieldFor(form, 'Rider Name')) return;
    form.dataset.psSafeguardsVersion='20261021-bigair-athlete';
    if(form.dataset.psSafeguardsReady==='true') {specialEntryFields(form);waitingList(form);isolateSpecialEntry(form);return;}
    form.dataset.psSafeguardsReady = 'true';
    form.removeAttribute('novalidate');
    lockQuantity(form);
    specialEntryFields(form);
    waitingList(form);
    buildTourSchedule(form);
    ensureProfileFields(form);
    improveNewTeamFlow(form);
    moveProfilePhotoBeforeProfilePromotion(form);
    improveSavedTeamReuse(form);

    const note = document.createElement('aside');
    note.className = 'ps-registration-note';
    note.innerHTML = '<strong>One named team, one simple registration flow</strong><p>Complete the roster for one horse, rider, and skier or snowboarder. To take this same team to more qualifiers, use the tour-schedule options below and add every selected stop in one checkout. Register a different team separately.</p>';
    form.prepend(note);

    const resetReview = () => {
      delete form.dataset.psRosterConfirmed;
      form.querySelector('.ps-registration-review')?.remove();
    };
    form.addEventListener('input', resetReview);
    form.addEventListener('change', resetReview);

  }

  async function handleRegistrationSubmit(form,event) {
      configureBigAirAthlete(form);
      const problems = validate(form);
      if (problems.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showErrors(form, problems);
        return;
      }
      clearErrors(form);
      if (form.dataset.psRosterConfirmed !== 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        showReview(form, event.submitter);
        return;
      }
      if (selectedDivision(form)==='Big Air' && form.dataset.psBigAirCartChecked!=='true') {
        event.preventDefault();event.stopImmediatePropagation();
        const submitter=event.submitter;
        try {
          const response=await fetch('/cart.js',{headers:{Accept:'application/json'}});
          if(!response.ok)throw Error('We could not check your Big Air entries. Please try again.');
          const cart=await response.json(),norm=v=>String(v||'').trim().toLowerCase().replace(/\s+/g,' ');
          const name=norm(fieldFor(form,'Skier or Snowboarder Name')?.value),email=norm(fieldFor(form,'Skier or Snowboarder Email')?.value);
          const variant=String(form.elements.namedItem('id')?.value||'');
          const count=cart.items.filter(i=>String(i.variant_id)===variant).filter(i=>{const p=i.properties||{};return name===norm(p['Athlete Name']||p['Skier or Snowboarder Name']) || email&&email===norm(p['Athlete Email']||p['Skier or Snowboarder Email']);}).reduce((n,i)=>n+i.quantity,0);
          if(count>=2)throw Error('This athlete already has two Big Air entries for this event in the cart. Please review your cart. The limit is two entries per athlete per event, including prior purchases.');
          const properties={};new FormData(form).forEach((v,k)=>{const match=k.match(/^properties\[([^\]]+)\]$/);if(match&&typeof v==='string')properties[match[1]]=v;});
          const token=new URLSearchParams(location.search).get('team_session');
          const check=await fetch(token?'https://pro-skijor-team-manager.onrender.com/storefront/waitlist?action=bigair-check':'/apps/team-manager?action=bigair-check',{method:'POST',headers:{'content-type':'application/json',...(token?{authorization:'Bearer '+token}:{})},body:JSON.stringify({variantId:variant,properties,additional:count+1})});
          const result=await check.json();
          if(check.status===401)throw Error('Please sign in to your PRO Skijor account before registering for Big Air so we can check the two-entry limit. Use the account link at the top of this page, then return here.');
          if(!check.ok)throw Error(result.error||'Your Big Air entry limit could not be confirmed. Please try again.');
          let entryId=form.elements.namedItem('properties[_Big Air Entry ID]');
          if(!entryId){entryId=document.createElement('input');entryId.type='hidden';entryId.name='properties[_Big Air Entry ID]';form.append(entryId);}
          entryId.value=crypto.randomUUID();
          form.dataset.psBigAirCartChecked='true';form.requestSubmit(submitter);
        } catch(error) {showErrors(form,[{message:error.message}]);}
        finally {delete form.dataset.psBigAirCartChecked;}
        return;
      }
      if (selectedTourItems(form).length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        await addTourScheduleToCart(form, event.submitter || form.querySelector('[type="submit"]'));
        return;
      }
      prepareAdditionalItems(form);
  }
  document.addEventListener('submit',event=>{const form=event.target;if(form?.dataset?.psSafeguardsVersion==='20261021-bigair-athlete')handleRegistrationSubmit(form,event);},true);

  function scan() {
    addStyles();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
  new MutationObserver(scan).observe(document.documentElement, {childList:true, subtree:true});
})();
